(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4222],{

/***/ 17285:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.AmpStateContext = void 0;

var _react = _interopRequireDefault(__webpack_require__(67294));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var AmpStateContext = _react["default"].createContext({});

exports.AmpStateContext = AmpStateContext;

if (false) {}

/***/ }),

/***/ 49546:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.isInAmpMode = isInAmpMode;
exports.useAmp = useAmp;

var _react = _interopRequireDefault(__webpack_require__(67294));

var _ampContext = __webpack_require__(17285);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function isInAmpMode() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$ampFirst = _ref.ampFirst,
      ampFirst = _ref$ampFirst === void 0 ? false : _ref$ampFirst,
      _ref$hybrid = _ref.hybrid,
      hybrid = _ref$hybrid === void 0 ? false : _ref$hybrid,
      _ref$hasQuery = _ref.hasQuery,
      hasQuery = _ref$hasQuery === void 0 ? false : _ref$hasQuery;

  return ampFirst || hybrid && hasQuery;
}

function useAmp() {
  // Don't assign the context value to a variable to save bytes
  return isInAmpMode(_react["default"].useContext(_ampContext.AmpStateContext));
}

if (typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) {
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 16505:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _defineProperty = __webpack_require__(930);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.defaultHead = defaultHead;
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(67294));

var _sideEffect = _interopRequireDefault(__webpack_require__(70148));

var _ampContext = __webpack_require__(17285);

var _headManagerContext = __webpack_require__(60523);

var _amp = __webpack_require__(49546);

var _utils = __webpack_require__(67206);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function defaultHead() {
  var inAmpMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var head = [/*#__PURE__*/_react["default"].createElement("meta", {
    charSet: "utf-8"
  })];

  if (!inAmpMode) {
    head.push( /*#__PURE__*/_react["default"].createElement("meta", {
      name: "viewport",
      content: "width=device-width"
    }));
  }

  return head;
}

function onlyReactElement(list, child) {
  // React children can be "string" or "number" in this case we ignore them for backwards compat
  if (typeof child === 'string' || typeof child === 'number') {
    return list;
  } // Adds support for React.Fragment


  if (child.type === _react["default"].Fragment) {
    return list.concat(_react["default"].Children.toArray(child.props.children).reduce(function (fragmentList, fragmentChild) {
      if (typeof fragmentChild === 'string' || typeof fragmentChild === 'number') {
        return fragmentList;
      }

      return fragmentList.concat(fragmentChild);
    }, []));
  }

  return list.concat(child);
}

var METATYPES = ['name', 'httpEquiv', 'charSet', 'itemProp'];
/*
 returns a function for filtering head child elements
 which shouldn't be duplicated, like <title/>
 Also adds support for deduplicated `key` properties
*/

function unique() {
  var keys = new Set();
  var tags = new Set();
  var metaTypes = new Set();
  var metaCategories = {};
  return function (h) {
    var isUnique = true;
    var hasKey = false;

    if (h.key && typeof h.key !== 'number' && h.key.indexOf('$') > 0) {
      hasKey = true;
      var key = h.key.slice(h.key.indexOf('$') + 1);

      if (keys.has(key)) {
        isUnique = false;
      } else {
        keys.add(key);
      }
    } // eslint-disable-next-line default-case


    switch (h.type) {
      case 'title':
      case 'base':
        if (tags.has(h.type)) {
          isUnique = false;
        } else {
          tags.add(h.type);
        }

        break;

      case 'meta':
        for (var i = 0, len = METATYPES.length; i < len; i++) {
          var metatype = METATYPES[i];
          if (!h.props.hasOwnProperty(metatype)) continue;

          if (metatype === 'charSet') {
            if (metaTypes.has(metatype)) {
              isUnique = false;
            } else {
              metaTypes.add(metatype);
            }
          } else {
            var category = h.props[metatype];
            var categories = metaCategories[metatype] || new Set();

            if ((metatype !== 'name' || !hasKey) && categories.has(category)) {
              isUnique = false;
            } else {
              categories.add(category);
              metaCategories[metatype] = categories;
            }
          }
        }

        break;
    }

    return isUnique;
  };
}
/**
 *
 * @param headElements List of multiple <Head> instances
 */


function reduceComponents(headElements, props) {
  return headElements.reduce(function (list, headElement) {
    var headElementChildren = _react["default"].Children.toArray(headElement.props.children);

    return list.concat(headElementChildren);
  }, []).reduce(onlyReactElement, []).reverse().concat(defaultHead(props.inAmpMode)).filter(unique()).reverse().map(function (c, i) {
    var key = c.key || i;

    if ( true && !props.inAmpMode) {
      if (c.type === 'link' && c.props['href'] && // TODO(prateekbh@): Replace this with const from `constants` when the tree shaking works.
      ['https://fonts.googleapis.com/css', 'https://use.typekit.net/'].some(function (url) {
        return c.props['href'].startsWith(url);
      })) {
        var newProps = _objectSpread({}, c.props || {});

        newProps['data-href'] = newProps['href'];
        newProps['href'] = undefined; // Add this attribute to make it easy to identify optimized tags

        newProps['data-optimized-fonts'] = true;
        return /*#__PURE__*/_react["default"].cloneElement(c, newProps);
      }
    }

    if (false) { var srcMessage; }

    return /*#__PURE__*/_react["default"].cloneElement(c, {
      key: key
    });
  });
}
/**
 * This component injects elements to `<head>` of your page.
 * To avoid duplicated `tags` in `<head>` you can use the `key` property, which will make sure every tag is only rendered once.
 */


function Head(_ref) {
  var children = _ref.children;
  var ampState = (0, _react).useContext(_ampContext.AmpStateContext);
  var headManager = (0, _react).useContext(_headManagerContext.HeadManagerContext);
  return /*#__PURE__*/_react["default"].createElement(_sideEffect["default"], {
    reduceComponentsToState: reduceComponents,
    headManager: headManager,
    inAmpMode: (0, _amp).isInAmpMode(ampState)
  }, children);
}

var _default = Head;
exports["default"] = _default;

if (typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) {
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 70148:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _toConsumableArray = __webpack_require__(7980);

var _classCallCheck = __webpack_require__(33227);

var _createClass = __webpack_require__(88361);

var _assertThisInitialized = __webpack_require__(92191);

var _inherits = __webpack_require__(85971);

var _possibleConstructorReturn = __webpack_require__(52715);

var _getPrototypeOf = __webpack_require__(91193);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(67294));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

var isServer = false;

var _class = /*#__PURE__*/function (_react$Component) {
  _inherits(_class, _react$Component);

  var _super = _createSuper(_class);

  function _class(props) {
    var _this;

    _classCallCheck(this, _class);

    _this = _super.call(this, props);

    _this.emitChange = function () {
      if (_this._hasHeadManager) {
        _this.props.headManager.updateHead(_this.props.reduceComponentsToState(_toConsumableArray(_this.props.headManager.mountedInstances), _this.props));
      }
    };

    _this._hasHeadManager = _this.props.headManager && _this.props.headManager.mountedInstances;

    if (isServer && _this._hasHeadManager) {
      _this.props.headManager.mountedInstances.add(_assertThisInitialized(_this));

      _this.emitChange();
    }

    return _this;
  }

  _createClass(_class, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this._hasHeadManager) {
        this.props.headManager.mountedInstances.add(this);
      }

      this.emitChange();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.emitChange();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._hasHeadManager) {
        this.props.headManager.mountedInstances["delete"](this);
      }

      this.emitChange();
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return _class;
}(_react.Component);

exports["default"] = _class;

/***/ }),

/***/ 65988:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ Accordion; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49642);
/* harmony import */ var _components_elements_Spacer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1253);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);







var Accordion = function Accordion(_ref) {
  var accordionTitle = _ref.accordionTitle,
      children = _ref.children,
      contentsLength = _ref.contentsLength,
      _ref$isDefaultOpen = _ref.isDefaultOpen,
      isDefaultOpen = _ref$isDefaultOpen === void 0 ? false : _ref$isDefaultOpen;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(isDefaultOpen),
      isExpand = _useState[0],
      setIsExpand = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0),
      childHeight = _useState2[0],
      setChildHeight = _useState2[1];

  var childElement = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (childElement.current) {
      var _childElement$current;

      var height = (_childElement$current = childElement.current) === null || _childElement$current === void 0 ? void 0 : _childElement$current.clientHeight;
      setChildHeight(height);
    }
  }, []);

  var handleClick = function handleClick() {
    if (childElement.current) {
      setIsExpand(!isExpand);
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(AccordionTitle, {
      onClick: handleClick,
      children: [contentsLength > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Icon, {
        isExpand: isExpand
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Title, {
        children: accordionTitle
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_components_elements_Spacer__WEBPACK_IMPORTED_MODULE_2__/* .Spacer */ .L, {
      h: {
        sp: 10,
        pc: 18
      }
    }), contentsLength === 0 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(NoItemText, {
      children: "\u305F\u3060\u3044\u307E\u63B2\u8F09\u3059\u3079\u304D\u4E8B\u9805\u306F\u3054\u3056\u3044\u307E\u305B\u3093\u3002"
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(AccordionItems, {
      isExpand: isExpand,
      childHeight: childHeight,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        ref: childElement,
        children: children
      })
    })]
  });
};
var AccordionTitle = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Accordion__AccordionTitle",
  componentId: "sc-1afnqmj-0"
})(["display:flex;align-items:center;gap:10px;&:hover{cursor:pointer;> h4{color:", ";}}@media screen and (max-width:1047px){align-items:flex-start;gap:6px;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.lightBlue */ .r.colors.lightBlue);
var Title = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].h4.withConfig */ .ZP.h4.withConfig({
  displayName: "Accordion__Title",
  componentId: "sc-1afnqmj-1"
})(["font-size:24px;font-weight:bold;color:", ";line-height:33.6px;@media screen and (max-width:1047px){font-size:18px;line-height:23.4px;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.trialBlue */ .r.colors.trialBlue);
var NoItemText = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "Accordion__NoItemText",
  componentId: "sc-1afnqmj-2"
})(["font-size:16px;line-height:25.6px;color:", ";@media screen and (max-width:1047px){font-size:15px;line-height:24px;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.textTitle */ .r.colors.textTitle);
var AccordionItems = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Accordion__AccordionItems",
  componentId: "sc-1afnqmj-3"
})(["height:", ";opacity:", ";transition:height 0.2s linear,opacity 0.5s ease-in;overflow:hidden;"], function (_ref2) {
  var isExpand = _ref2.isExpand,
      childHeight = _ref2.childHeight;
  return isExpand ? "".concat(childHeight, "px") : '0px';
}, function (_ref3) {
  var isExpand = _ref3.isExpand;
  return isExpand ? 1 : 0;
});
var Icon = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "Accordion__Icon",
  componentId: "sc-1afnqmj-4"
})(["transition:all 0.25s ease;overflow:hidden;position:relative;padding-top:2px;padding-right:10px;width:40px;height:40px;&::before,&::after{content:'';display:inline-block;width:30px;height:4px;position:absolute;top:50%;background-image:url('/images/accordion.png');}&::after{transform:rotate(90deg);transition:transform 0.4s ease;}", " @media screen and (max-width:1047px){padding-top:7px;padding-right:16px;width:16px;height:23px;&::before,&::after{width:16px;height:2.13px;}}"], function (_ref4) {
  var isExpand = _ref4.isExpand;
  return isExpand ? (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(["&::after{transform:rotate(0);}"]) : '';
});

/***/ }),

/***/ 97071:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* binding */ PDFIcon; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/elements/Icon/PDF/pdf.svg
var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgPdf = function SvgPdf(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 24"
  }, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 1777"
  }, /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u30D1\\u30B9 1540",
    d: "M5.963 5.234V.291L.278 5.976h4.943c.534 0 .742-.208.742-.742Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u30D1\\u30B9 1541",
    d: "M8.819 11.945a8.259 8.259 0 0 0 .414-1.759c.207-1.008-.052-1.629-.594-1.55s-.672.7-.62 1.344a5.342 5.342 0 0 0 .594 1.784s.1.258.206.181Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u30D1\\u30B9 1542",
    d: "M6.339 17.118a5.839 5.839 0 0 0-2.041 1.086c-.7.673-.648 1.267-.336 1.473s1.189-.414 1.732-1.06a5.145 5.145 0 0 0 .9-1.4c.004-.099-.047-.177-.255-.099Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u30D1\\u30B9 1543",
    d: "M8.214 16.028c.515-.206 2.377-.621 2.377-.621s-1.214-1.447-1.37-1.732c0 .001-.724 1.888-1.007 2.353Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u30D1\\u30B9 1544",
    d: "M17.051 0H6.97v5.864a1.171 1.171 0 0 1-1.164 1.174H0v16a.955.955 0 0 0 .949.957h16.1a.954.954 0 0 0 .949-.957V.956A.954.954 0 0 0 17.051 0Zm-3.106 17.849a7.087 7.087 0 0 1-2.917-1.886.23.23 0 0 0-.069-.015c-.15 0-1.82.485-3.088.848-1.854 3.341-3.7 4.294-4.567 3.189-.456-.582-.28-1.955 1.914-2.984a14.164 14.164 0 0 1 1.77-.668 31.5 31.5 0 0 0 1.573-3.579 10.185 10.185 0 0 1-1.072-2.772c-.1-1.081.357-2.059 1.276-2.059 1.171 0 2.04 1.132.668 5.111a12.589 12.589 0 0 0 1.673 2.246 13.561 13.561 0 0 1 2.784-.261c1.651.1 1.994.877 2.045 1.469a1.6 1.6 0 0 1-1.99 1.361Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u30D1\\u30B9 1545",
    d: "M13.761 15.555a6.219 6.219 0 0 0-2.069.258 6.871 6.871 0 0 0 2.093 1.035c.777.1 1.062-.232 1.062-.568s-.284-.673-1.086-.725Z"
  }))));
};
/* harmony default export */ var pdf = (SvgPdf);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/elements/Icon/PDF/index.tsx


var _excluded = ["size"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var PDFIcon = function PDFIcon(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'regular' : _ref$size,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledIcon, _objectSpread(_objectSpread({}, props), {}, {
    "data-size": size
  }));
};
var StyledIcon = (0,styled_components_browser_esm/* default */.ZP)(pdf).withConfig({
  displayName: "PDF__StyledIcon",
  componentId: "sc-18bayee-0"
})(["transition:fill 0.3s ease;fill:", ";&[data-size='regular']{width:18px;height:24px;}&[data-size='small']{width:12px;height:28px;}"], theme/* theme.colors.trialBlue */.r.colors.trialBlue);

/***/ }),

/***/ 22978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Head; }
/* harmony export */ });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var Head = function Head(_ref) {
  var _ogp$image, _ogp$type;

  var title = _ref.title,
      _ref$hasTitleSuffix = _ref.hasTitleSuffix,
      hasTitleSuffix = _ref$hasTitleSuffix === void 0 ? true : _ref$hasTitleSuffix,
      description = _ref.description,
      noindex = _ref.noindex,
      ogp = _ref.ogp;
  var ogpImage = (_ogp$image = ogp === null || ogp === void 0 ? void 0 : ogp.image) !== null && _ogp$image !== void 0 ? _ogp$image : {
    src: 'https://trial-holdings.inc/images/ogp.png',
    width: 1200,
    height: 630
  };
  var titleText = hasTitleSuffix ? "".concat(title, " | \u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9") : title;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("title", {
      children: titleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "description",
      content: description
    }), noindex && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "robots",
      content: "noindex, nofollow"
    }), ogp && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:type",
        content: (_ogp$type = ogp.type) !== null && _ogp$type !== void 0 ? _ogp$type : 'website'
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:url",
        content: "https://trial-holdings.inc/".concat(ogp.url)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:title",
        content: ogp.title || titleText
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:description",
        content: description
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image",
        content: ogpImage.src
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:width",
        content: "".concat(ogpImage.width)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:height",
        content: "".concat(ogpImage.height)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:site_name",
        content: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:locale",
        content: "ja_JP"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "icon",
      href: "/images/favicon.ico"
    })]
  });
};

/***/ }),

/***/ 24604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ PDFItem; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);
/* harmony import */ var _utils_date__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16645);
/* harmony import */ var _components_elements_Icon_PDF__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97071);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);






var PDFItem = function PDFItem(_ref) {
  var date = _ref.date,
      fileName = _ref.fileName,
      filePath = _ref.filePath;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(StyledLink, {
    href: filePath,
    target: "_blank",
    rel: "noreferrer noopener",
    children: [date && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Time, {
      dateTime: date,
      children: (0,_utils_date__WEBPACK_IMPORTED_MODULE_3__/* .formatDate */ .p6)(date, 'yyyy/MM/dd')
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Icon, {
      size: "small"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Name, {
      children: fileName
    })]
  });
};
var Time = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].time.withConfig */ .ZP.time.withConfig({
  displayName: "PDFItem__Time",
  componentId: "sc-12039hs-0"
})(["font-weight:700;line-height:1.6;"]);
var StyledLink = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].a.withConfig */ .ZP.a.withConfig({
  displayName: "PDFItem__StyledLink",
  componentId: "sc-12039hs-1"
})(["transition:color 0.3s ease;display:flex;align-items:center;gap:10px;padding-top:18px;padding-bottom:20px;width:100%;&:hover{> span{color:", ";text-decoration:underline;}> svg{fill:", ";}}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.lightBlue */ .r.colors.lightBlue, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.lightBlue */ .r.colors.lightBlue);
var Name = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "PDFItem__Name",
  componentId: "sc-12039hs-2"
})(["line-height:1.6;"]);
var Icon = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_components_elements_Icon_PDF__WEBPACK_IMPORTED_MODULE_1__/* .PDFIcon */ .H).withConfig({
  displayName: "PDFItem__Icon",
  componentId: "sc-12039hs-3"
})(["flex-shrink:0;"]);

/***/ }),

/***/ 16653:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ PDFList; }
/* harmony export */ });
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49642);
/* harmony import */ var _PDFItem__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24604);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var PDFList = function PDFList(_ref) {
  var pdfList = _ref.pdfList;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("ul", {
    children: pdfList.map(function (pdf) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Item, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_PDFItem__WEBPACK_IMPORTED_MODULE_2__/* .PDFItem */ .G, _objectSpread({}, pdf))
      }, pdf.id);
    })
  });
};
var Item = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].li.withConfig */ .ZP.li.withConfig({
  displayName: "PDFList__Item",
  componentId: "sc-mppgtj-0"
})(["display:flex;align-items:center;:not(:last-child){border-bottom:1px solid ", ";}"], _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.backgroundBlue */ .r.colors.backgroundBlue);

/***/ }),

/***/ 49745:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ MonthlySalesPDF; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32125);
/* harmony import */ var _components_elements_Accordion__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65988);
/* harmony import */ var _components_layouts_Ir_PDFList__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16653);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);





var MonthlySalesPDF = function MonthlySalesPDF(_ref) {
  var yearsPdf = _ref.yearsPdf;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Section, {
      children: yearsPdf.map(function (value, index) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_components_elements_Accordion__WEBPACK_IMPORTED_MODULE_0__/* .Accordion */ .U, {
            accordionTitle: value.accordionTitle,
            contentsLength: value.accordionItems.length,
            isDefaultOpen: value.isDefaultOpen,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_components_layouts_Ir_PDFList__WEBPACK_IMPORTED_MODULE_1__/* .PDFList */ .T, {
              pdfList: value.accordionItems
            })
          })
        }, "".concat(index).concat(value.accordionTitle));
      })
    })
  });
};
var Section = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].section.withConfig */ .ZP.section.withConfig({
  displayName: "Pdffiles__Section",
  componentId: "sc-161uj94-0"
})(["display:flex;flex-direction:column;gap:50px;h4{margin-bottom:0px !important;}"]);

/***/ }),

/***/ 15532:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);
/* harmony import */ var _components_layout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55548);
/* harmony import */ var _components_layouts_Head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22978);
/* harmony import */ var _components_layouts_Ir_Pdffiles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49745);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);









var TopicsCocotoraPage = function TopicsCocotoraPage() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(CompanyMain, {})
  });
};

/* harmony default export */ __webpack_exports__["default"] = (TopicsCocotoraPage);

TopicsCocotoraPage.getLayout = function (page) {
  var breadCrumbs = [{
    name: 'ホーム',
    path: '/'
  }, {
    name: '個人投資家の皆様へ',
    path: '/ir/investor/'
  }, {
    name: 'ココ見てトライアル',
    path: ''
  }];
  var yearsPdf = [{
    accordionTitle: 'ココ見てトライアル アーカイブ',
    accordionItems: [{
      id: '',
      fileName: '2025年6月期 ココ見てトライアル',
      filePath: '/retail-investor/topics-cocotora2025/'
    }, {
      id: '',
      fileName: '2024年６月期 TRIALレポート',
      filePath: 'https://report-k.pdcp.jp/141A/202409/a/'
    }],
    isDefaultOpen: true
  }];
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components_layouts_Head__WEBPACK_IMPORTED_MODULE_2__/* .Head */ .F, {
      title: "\u4F01\u696D\u60C5\u5831",
      description: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9\u306E\u4F01\u696D\u60C5\u5831\u3092\u63B2\u8F09\u3057\u3066\u3044\u307E\u3059\u3002",
      ogp: {
        url: 'company/'
      }
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components_layout__WEBPACK_IMPORTED_MODULE_1__/* .TitleLayout */ .$0, {
      title: "Investor Relations",
      subTitle: "\u682A\u4E3B\u30FB\u6295\u8CC7\u5BB6\u5411\u3051\u60C5\u5831",
      breadCrumbs: breadCrumbs,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(TopicsSection, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(TopicsTitleBuild, {
          children: ["\u4E2D\u671F\u7D4C\u55B6\u8A08\u753B", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(TopicsTitleBuildDate, {
            children: "(2027\u5E74\uFF16\u6708\u671F\uFF5E2029\u5E74\uFF16\u6708\u671F)"
          }), "\u306E\uFF11\u5E74\u76EE\u304C\u59CB\u307E\u308A\u307E\u3057\u305F\uFF01"]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(IntroText, {
          children: ["\u4ECA\u56DE\u306E\u300C\u30B3\u30B3\u898B\u3066\u30C8\u30E9\u30A4\u30A2\u30EB\u300D\u3067\u306F\u3001\u4E2D\u671F\u7D4C\u55B6\u8A08\u753B\uFF15\u3064\u306E\u91CD\u70B9\u6226\u7565\u306E\u3046\u3061\u3001", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("br", {
            className: "pc-only"
          }), "\u30C8\u30E9\u30A4\u30A2\u30EB\xD7\u897F\u53CB\u306E\u878D\u5408\u3092\u8C61\u5FB4\u3059\u308B\u65B0\u30D5\u30A9\u30FC\u30DE\u30C3\u30C8\u300C\u30C8\u30E9\u30A4\u30A2\u30EB\u897F\u53CB\u300D\u3092\u5FB9\u5E95\u89E3\u8AAC\u3057\u307E\u3059\uFF01"]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(ScrollableImageWrapper, {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(ScrollableImage, {
            src: "/images/topics_cocotora64.png",
            alt: "\u30C8\u30E9\u30A4\u30A2\u30EB\u897F\u53CB \u5FB9\u5E95\u89E3\u8AAC"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(SectionTitle, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
            children: "\u25CF"
          }), " \u300C\u30C8\u30E9\u30A4\u30A2\u30EB\u897F\u53CB\u300D\u8A95\u751F"]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(BirthFlex, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(BirthImage, {
            src: "/images/topics_cocotora42.png",
            alt: "\u30C8\u30E9\u30A4\u30A2\u30EB\u897F\u53CB"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(BirthText, {
            children: ["\u300CGMS\u518D\u751F\u300D\u30E2\u30C7\u30EB\u3065\u304F\u308A\u3092\u76EE\u6307\u3057\u305F", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("br", {
              className: "sp-only"
            }), "\u300C\u90FD\u5E02\u578B\u306E\u65B0\u30D5\u30A9\u30FC\u30DE\u30C3\u30C8\u300D"]
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(SectionText, {
          children: "\u99C5\u524D\u30FB\u5F92\u6B69\u5546\u570F\u3067\u7E41\u76DB\u5E97\u3092\u5B9F\u73FE\u3059\u308B\u305F\u3081\u3001\u300C\u98DF\u300D\u306E\u5F37\u5316\u3092\u8EF8\u306B\u3001\u5229\u4FBF\u6027\u306E\u5411\u4E0A\u3068\u975E\u98DF\u54C1\u306E\u5145\u5B9F\u3092\u56F3\u308B\u3002\u305D\u308C\u304C\u300C\u30C8\u30E9\u30A4\u30A2\u30EB\u897F\u53CB\u300D\u306E\u30B3\u30F3\u30BB\u30D7\u30C8\u3067\u3059\u3002\u897F\u53CB\u304C\u57F9\u3063\u3066\u304D\u305F\u3001\u99C5\u524D\u597D\u7ACB\u5730\u3092\u6D3B\u304B\u3057\u305F\u5730\u57DF\u306E\u751F\u6D3B\u9700\u8981\u3092\u6349\u3048\u308B\u5E97\u8217\u57FA\u76E4\u3002\u305D\u3053\u306B\u3001\u300CSkip Cart\u300D\u3084\u300C\u30A4\u30F3\u30B9\u30C8\u30A2\u30B5\u30A4\u30CD\u30FC\u30B8\u300D\u3092\u306F\u3058\u3081\u3068\u3059\u308B\u30C8\u30E9\u30A4\u30A2\u30EB\u306E\u30EA\u30C6\u30FC\u30EB\u30C6\u30C3\u30AF\u3068\u3001\u5E97\u8217\u904B\u55B6\u306E\u30CE\u30A6\u30CF\u30A6\u3092\u878D\u5408\u3002\u4E21\u793E\u306E\u5F37\u307F\u3092\u639B\u3051\u5408\u308F\u305B\u305F\u65B0\u30D5\u30A9\u30FC\u30DE\u30C3\u30C8\u300C\u30C8\u30E9\u30A4\u30A2\u30EB\u897F\u53CB\u300D\u304C\u8A95\u751F\u3057\u307E\u3057\u305F\u3002"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(ScrollableImageWrapper, {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(ScrollableImage, {
            src: "/images/topics_cocotora43.png",
            alt: "\u30C8\u30E9\u30A4\u30A2\u30EB\u897F\u53CB \u8A73\u7D30"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(SectionTitleFlex, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(SectionTitleText, {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
              children: "\u25CF"
            }), " \u300C\u30C8\u30E9\u30A4\u30A2\u30EB\u897F\u53CB\u300D\u30D5\u30A9\u30FC\u30DE\u30C3\u30C8\u8CAC\u4EFB\u8005\u30A4\u30F3\u30BF\u30D3\u30E5\u30FC"]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(SectionTitleImage, {
            src: "/images/topics_cocotora57.png",
            alt: "\u30A4\u30F3\u30BF\u30D3\u30E5\u30FC"
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(QASection, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(QABlock, {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(QARow, {
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(QIcon, {
                children: "Q"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(QText, {
                children: "\u4ECA\u56DE\u306E\u65B0\u30D5\u30A9\u30FC\u30DE\u30C3\u30C8\u3067\u306F\u3001\u5F93\u6765\u306E\u304A\u5E97\u3068\u6BD4\u3079\u3066\u4F55\u3092\u6700\u3082\u5927\u304D\u304F\u5909\u3048\u305F\u306E\u3067\u3057\u3087\u3046\u304B\uFF1F"
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(QARow, {
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(AIcon, {
                children: "A"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(AText, {
                children: ["\u4E00\u756A\u5206\u304B\u308A\u3084\u3059\u3044\u5909\u5316\u306F\u3001\u751F\u9BAE\u98DF\u54C1\u306E\u5F37\u5316\u3067\u3059\u3002\u751F\u9BAE\u306F\u5927\u304D\u306A\u96C6\u5BA2\u30C9\u30E9\u30A4\u30D0\u30FC\u3067\u3042\u308A\u3001\u7AF6\u4E89\u529B\u3092\u9AD8\u3081\u308B\u3046\u3048\u3067\u6B20\u304B\u305B\u306A\u3044\u30AB\u30C6\u30B4\u30EA\u30FC\u3060\u3068\u8003\u3048\u3066\u3044\u307E\u3059\u3002 \u4E00\u65B9\u3067\u3001\u751F\u9BAE\u3060\u3051\u3067\u306A\u304F\u975E\u98DF\u54C1\u3082\u5E45\u5E83\u304F\u63C3\u3048\u3001\u65E5\u5E38\u751F\u6D3B\u306B\u5FC5\u8981\u306A\u3082\u306E\u3092\u4E00\u3064\u306E\u5E97\u8217\u3067\u8CFC\u5165\u3067\u304D\u308B\u300C\u30EF\u30F3\u30B9\u30C8\u30C3\u30D7\u30B7\u30E7\u30C3\u30D4\u30F3\u30B0\u300D\u3092\u76EE\u6307\u3057\u3066\u3044\u307E\u3059\u3002\u5DEE\u5225\u5316\u3067\u304D\u308B\u5F37\u3044\u30AB\u30C6\u30B4\u30EA\u30FC\u3092\u3064\u304F\u308A\u3001", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(HighlightText, {
                  children: "\u300C\u6B32\u3057\u3044\u3082\u306E\u304C\u3042\u308B\u300D\u300C\u304A\u3044\u3057\u3044\u3082\u306E\u304C\u3042\u308B\u300D\u300C\u4FBF\u5229\u306B\u8CB7\u3048\u308B\u300D"
                }), "\u3068\u611F\u3058\u3066\u3044\u305F\u3060\u3051\u308B\u5E97\u8217\u3092\u76EE\u6307\u3057\u3066\u3044\u307E\u3059\u3002"]
              })]
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(QABlock, {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(QARow, {
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(QIcon, {
                children: "Q"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(QText, {
                children: "\u3053\u308C\u307E\u3067\u306E\u5E97\u8217\u3065\u304F\u308A\u3067\u5F97\u305F\u77E5\u898B\u3092\u3001\u4ECA\u5F8C\u3069\u306E\u3088\u3046\u306B\u65B0\u3057\u3044\u5E97\u8217\u3078\u751F\u304B\u3057\u3066\u3044\u304D\u305F\u3044\u3067\u3059\u304B\uFF1F"
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(QARow, {
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(AIcon, {
                children: "A"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(AText, {
                children: ["\u3053\u308C\u307E\u3067\u3001\u99C5\u524D\u578B\u3084\u90FD\u5FC3\u578B\u3001\u591A\u5C64\u968E\u578B\u306A\u3069\u3001\u3055\u307E\u3056\u307E\u306A\u5E97\u8217\u3092\u904B\u55B6\u3059\u308B\u4E2D\u3067\u3001\u305D\u308C\u305E\u308C\u306E\u5546\u570F\u3084\u5E97\u8217\u7279\u6027\u306B\u5408\u3063\u305F\u77E5\u898B\u3092\u84C4\u7A4D\u3057\u3066\u304D\u307E\u3057\u305F\u3002\u4ECA\u5F8C\u306F\u3001", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(HighlightText, {
                  children: "\u6210\u529F\u4E8B\u4F8B\u3092\u300C\u6B66\u5668\u300D\u3068\u3057\u3066\u5897\u3084\u3057\u3001\u5E97\u8217\u3054\u3068\u306B\u6700\u9069\u306B\u7D44\u307F\u5408\u308F\u305B\u306A\u304C\u3089\u3001\u7AF6\u4E89\u529B\u3092\u9AD8\u3081\u3066\u3044\u304D\u305F\u3044"
                }), "\u3068\u8003\u3048\u3066\u3044\u307E\u3059\u3002"]
              })]
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(QABlock, {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(QARow, {
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(QIcon, {
                children: "Q"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(QText, {
                children: "\u5B9F\u969B\u306E\u904B\u55B6\u3092\u901A\u3058\u3066\u3001\u65B0\u305F\u306B\u898B\u3048\u3066\u304D\u305F\u8AB2\u984C\u306F\u3042\u308A\u307E\u3059\u304B\uFF1F"
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(QARow, {
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(AIcon, {
                children: "A"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(AText, {
                children: ["\u5B9F\u969B\u306B\u904B\u55B6\u3059\u308B\u4E2D\u3067\u898B\u3048\u3066\u304D\u305F\u8AB2\u984C\u306F\u3001\u6210\u529F\u4E8B\u4F8B\u3092\u305D\u306E\u307E\u307E\u5168\u5E97\u8217\u306B\u6A2A\u5C55\u958B\u3067\u304D\u308B\u308F\u3051\u3067\u306F\u306A\u3044\u3068\u3044\u3046\u70B9\u3067\u3059\u3002\u5E97\u8217\u3054\u3068\u306B\u5546\u570F\u3084\u5BA2\u5C64\u3001\u7AF6\u4E89\u74B0\u5883\u3001\u5E97\u8217\u7279\u6027\u304C\u7570\u306A\u308B\u305F\u3081\u3001\u54C1\u63C3\u3048\u3084\u4FA1\u683C\u3001\u58F2\u5834\u3092\u305D\u308C\u305E\u308C\u306B\u5408\u308F\u305B\u3066\u8ABF\u6574\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002\u307E\u305F\u3001\u6539\u88C5\u3057\u3066\u7D42\u308F\u308A\u3067\u306F\u306A\u304F\u3001\u65B0\u305F\u306B\u6210\u679C\u304C\u51FA\u305F\u65BD\u7B56\u3092\u4ED6\u5E97\u8217\u306B\u3082\u53D6\u308A\u5165\u308C\u306A\u304C\u3089\u3001", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(HighlightText, {
                  children: "\u7D99\u7D9A\u7684\u306B\u5E97\u8217\u3092\u30A2\u30C3\u30D7\u30C7\u30FC\u30C8\u3057\u3066\u3044\u304F"
                }), "\u3053\u3068\u3082\u91CD\u8981\u3060\u3068\u8003\u3048\u3066\u3044\u307E\u3059\u3002"]
              })]
            })]
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(BottomFlex, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(PersonLeft, {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(PersonTopText, {
              children: "\uFF3C \u3053\u306E\u65B9\u306B\u805E\u304D\u307E\u3057\u305F \uFF0F"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(PersonImage, {
              src: "/images/topics_cocotora44.png",
              alt: "\u51FA\u53E3 \u76F4\u6A39"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(PersonInfo, {
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("p", {
                children: "\u30C8\u30E9\u30A4\u30A2\u30EB\u897F\u53CB"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("p", {
                children: "\u30D5\u30A9\u30FC\u30DE\u30C3\u30C8\u8CAC\u4EFB\u8005"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("p", {
                children: "\u51FA\u53E3 \u76F4\u6A39"
              })]
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(MessageRight, {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(MessageBox, {
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(MessageTitleWrapper, {
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(MessageTitle, {
                  children: "\u682A\u4E3B\u30FB\u6295\u8CC7\u5BB6\u306E\u7686\u3055\u307E\u3078"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(MessageContent, {
                children: ["\u65E5\u672C\u306E\u5C0F\u58F2\u696D\u754C\u306B\u306F\u3001\u5F37\u3044\u5546\u54C1\u529B\u3092\u6301\u3064\u9B45\u529B\u7684\u306A\u4F01\u696D\u304C\u6570\u591A\u304F\u5B58\u5728\u3057\u307E\u3059\u3002", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("br", {}), "\u305D\u306E\u4E2D\u3067\u30C8\u30E9\u30A4\u30A2\u30EB\u897F\u53CB\u3092\u9078\u3093\u3067\u3044\u305F\u3060\u3051\u308B\u3088\u3046\u5DEE\u5225\u5316\u3092\u56F3\u308A\u306A\u304C\u3089\u3001", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("br", {
                  className: "pc-only"
                }), "\u5E97\u8217\u306E\u9B45\u529B\u3092\u3055\u3089\u306B\u9AD8\u3081\u3066\u3044\u304D\u305F\u3044\u3068\u8003\u3048\u3066\u3044\u307E\u3059\u3002\u307E\u3060\u5B8C\u6210\u5F62\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u304C\u3001", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("br", {
                  className: "pc-only"
                }), "\u4E00\u3064\u3072\u3068\u3064\u5F37\u307F\u3092\u7A4D\u307F\u4E0A\u3052\u3066\u3001\u7AF6\u4E89\u529B\u306E\u3042\u308B\u30E2\u30C7\u30EB\u3078\u78E8\u304D\u4E0A\u3052\u3066\u3044\u304D\u307E\u3059\u3002", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("br", {}), "\u3053\u308C\u304B\u3089\u3082\u3001\u3088\u308A\u826F\u3044\u5E97\u8217\u3065\u304F\u308A\u3078\u306E\u6311\u6226\u3092\u7D9A\u3051\u3066\u3044\u304D\u307E\u3059\u3002"]
              })]
            })
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(SectionTitle, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
            children: "\u25CF"
          }), " \u300C\u30C8\u30E9\u30A4\u30A2\u30EB\u897F\u53CB\u300D\u306E\u5E97\u5185\u3092\u306E\u305E\u3044\u3066\u307F\u3088\u3046"]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(SectionText, {
          children: "\u30C8\u30E9\u30A4\u30A2\u30EB\u897F\u53CB\u3067\u306F\u3001\u30C8\u30E9\u30A4\u30A2\u30EB\u306E\u30EA\u30C6\u30FC\u30EB\u30C6\u30C3\u30AF\u3084\u751F\u9BAE\u30FB\u60E3\u83DC\u306E\u30CE\u30A6\u30CF\u30A6\u3068\u3001\u897F\u53CB\u306E\u4FA1\u5024\u8A34\u6C42\u306EPB\u5546\u54C1\u300C\u307F\u306A\u3055\u307E\u306E\u304A\u58A8\u4ED8\u304D\u300D\u3092\u306F\u3058\u3081\u3068\u3059\u308B\u5546\u54C1\u529B\u306A\u3069\u3001\u4E21\u793E\u306E\u5F37\u307F\u3092\u878D\u5408\u3002\u5F93\u6765\u306E\u58F2\u5834\u304B\u3089\u3001\u3088\u308A\u5546\u54C1\u3092\u9078\u3073\u3084\u3059\u304F\u3001\u305D\u306E\u9B45\u529B\u304C\u4F1D\u308F\u308B\u58F2\u5834\u3078\u3002\u751F\u9BAE\u306E\u9BAE\u5EA6\u30FB\u54C1\u63C3\u3048\u306E\u5F37\u5316\u306B\u52A0\u3048\u3001\u304A\u9152\u3084\u30D3\u30E5\u30FC\u30C6\u30A3\u30FC\u306A\u3069\u306E\u30AB\u30C6\u30B4\u30EA\u30FC\u3067\u3082\u3001\u304A\u5BA2\u69D8\u306B\u300C\u3053\u306E\u5E97\u306B\u6765\u305F\u3044\u300D\u3068\u601D\u3063\u3066\u3044\u305F\u3060\u3051\u308B\u58F2\u5834\u3065\u304F\u308A\u3092\u9032\u3081\u3066\u3044\u307E\u3059\u3002"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(InsideGrid, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(InsideReplaceImage, {
            src: "/images/topics_cocotora65.png",
            alt: "\u300CSkip Cart\u300D\u3067\u30B9\u30DE\u30FC\u30C8\u3067\u4FBF\u5229\u306A\u304A\u8CB7\u3044\u7269\u4F53\u9A13",
            width: 500,
            height: 190,
            style: {
              maxWidth: '500px'
            }
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(InsideReplaceImage, {
            src: "/images/topics_cocotora67.png",
            alt: "\u300C\u30A4\u30F3\u30B9\u30C8\u30A2\u30B5\u30A4\u30CD\u30FC\u30B8\u300D\u3067\u81E8\u5834\u611F\u306E\u3042\u308B\u697D\u3057\u3044\u58F2\u5834",
            width: 500,
            height: 235,
            style: {
              maxWidth: '500px'
            }
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(InsideReplaceImage, {
            src: "/images/topics_cocotora66.png",
            alt: "\u751F\u9BAE\u3092\u4E2D\u5FC3\u3068\u3059\u308B\u98DF\u54C1\u5F37\u5316\u3067\u300C\u5546\u54C1\u529B\u30A2\u30C3\u30D7\u300D",
            width: 500,
            height: 234,
            style: {
              maxWidth: '500px'
            }
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(InsideReplaceImage, {
            src: "/images/topics_cocotora68.png",
            alt: "\u300C\u4E5D\u5DDE\u611B\u300D\u3042\u3075\u308C\u308B\u5546\u54C1\u307E\u3067\u8C4A\u5BCC\u306B\u53D6\u308A\u6271\u3044",
            width: 500,
            height: 182,
            style: {
              maxWidth: '500px'
            }
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(SectionTitleFlex, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(SectionTitleText, {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
              children: "\u25CF"
            }), " \u30C8\u30E9\u30A4\u30A2\u30EB\u897F\u53CB \u5E97\u9577\u30A4\u30F3\u30BF\u30D3\u30E5\u30FC"]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(SectionTitleImage, {
            src: "/images/topics_cocotora57.png",
            alt: "\u30A4\u30F3\u30BF\u30D3\u30E5\u30FC"
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(QASection, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(QABlock, {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(QARow, {
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(QIcon, {
                children: "Q"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(QText, {
                children: "\u696D\u614B\u8EE2\u63DB\u306E\u524D\u5F8C\u3067\u3069\u306E\u3088\u3046\u306A\u5909\u5316\u304C\u3042\u308A\u307E\u3059\u304B\uFF1F"
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(QARow, {
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(AIcon, {
                children: "A"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(AText, {
                children: ["\u5F93\u6765\u306E\u304A\u5BA2\u3055\u307E\u306B\u52A0\u3048\u3001\u30D5\u30A1\u30DF\u30EA\u30FC\u5C64\u3084\u82E5\u3044\u4E16\u4EE3\u306B\u3082\u5229\u7528\u3044\u305F\u3060\u3051\u308B\u3088\u3046\u306B\u306A\u308A\u3001", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(HighlightText, {
                  children: "\u304A\u5BA2\u3055\u307E\u5C64\u306E\u5E83\u304C\u308A\u3092\u611F\u3058\u3066\u3044\u307E\u3059"
                }), "\u3002", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("br", {}), "\u897F\u53CB\u304C\u6301\u3064\u5E97\u8217\u3084\u4EBA\u6750\u306E\u30DD\u30C6\u30F3\u30B7\u30E3\u30EB\u306B\u3001\u30C8\u30E9\u30A4\u30A2\u30EB\u306E\u30CE\u30A6\u30CF\u30A6\u3084\u65B0\u305F\u306A\u53D6\u308A\u7D44\u307F\u3092\u639B\u3051\u5408\u308F\u305B\u308B\u3053\u3068\u3067\u3001\u5E97\u8217\u306E\u9B45\u529B\u3092\u3055\u3089\u306B\u5F15\u304D\u51FA\u3057\u3066\u3044\u3051\u308B\u3068\u8003\u3048\u3066\u3044\u307E\u3059\u3002"]
              })]
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(QABlock, {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(QARow, {
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(QIcon, {
                children: "Q"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(QText, {
                children: "\u300C\u30C8\u30E9\u30A4\u30A2\u30EB\u897F\u53CB\u300D\u3068\u3057\u3066\u904B\u55B6\u3057\u3066\u304D\u3066\u3001\u7279\u306B\u6CE8\u76EE\u306E\u58F2\u5834\u306F\u3069\u3053\u3067\u3059\u304B\uFF1F"
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(QARow, {
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(AIcon, {
                children: "A"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(AText, {
                children: ["\u3084\u306F\u308A\u3001", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(HighlightText, {
                  children: "\u304A\u8089\u3084\u60E3\u83DC\u3092\u306F\u3058\u3081\u3068\u3059\u308B\u751F\u9BAE\u98DF\u54C1\u3067\u3059"
                }), "\u3002\u5B9F\u969B\u306B\u304A\u5BA2\u3055\u307E\u304B\u3089\u652F\u6301\u3057\u3066\u3044\u305F\u3060\u3044\u3066\u3044\u308B\u3068\u3044\u3046\u624B\u5FDC\u3048\u3092\u611F\u3058\u3066\u3044\u307E\u3059\u3002", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("br", {}), "\u65E5\u5E38\u306E\u304A\u8CB7\u3044\u7269\u3067\u300C\u307E\u305A\u9078\u3070\u308C\u308B\u5E97\u300D\u306B\u306A\u308B\u305F\u3081\u306B\u306F\u3001\u751F\u9BAE\u306E\u529B\u304C\u975E\u5E38\u306B\u91CD\u8981\u3067\u3059\u3002\u307E\u305F\u3001\u4E5D\u5DDE\u306A\u3069\u897F\u65E5\u672C\u3067\u99B4\u67D3\u307F\u306E\u3042\u308B\u5546\u54C1\u3092\u6771\u4EAC\u3067\u3082\u8CFC\u5165\u3067\u304D\u308B\u3053\u3068\u3082\u3001\u30C8\u30E9\u30A4\u30A2\u30EB\u897F\u53CB\u306A\u3089\u3067\u306F\u306E\u9B45\u529B\u3060\u3068\u8003\u3048\u3066\u3044\u307E\u3059\u3002\u6771\u4EAC\u3067\u306F\u306A\u304B\u306A\u304B\u898B\u304B\u3051\u306A\u3044\u5546\u54C1\u3082\u3042\u308B\u305F\u3081\u3001\u305D\u3046\u3057\u305F\u54C1\u63C3\u3048\u304C\u65B0\u305F\u306A\u6765\u5E97\u7406\u7531\u306B\u3082\u3064\u306A\u304C\u3063\u3066\u3044\u307E\u3059\u3002"]
              })]
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(LastQARow, {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(LastQAColumn, {
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(QARow, {
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(QIcon, {
                  children: "Q"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(QText, {
                  children: "\u4ECA\u5F8C\u3001\u3055\u3089\u306B\u826F\u304F\u3057\u3066\u3044\u304D\u305F\u3044\u70B9\u3084\u3001\u65B0\u3057\u304F\u6311\u6226\u3057\u305F\u3044\u3053\u3068\u306F\u3042\u308A\u307E\u3059\u304B\uFF1F"
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(QARow, {
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(AIcon, {
                  children: "A"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(AText, {
                  children: ["\u73FE\u5728\u306F\u3001\u307E\u3060\u5341\u5206\u306B\u80B2\u3061\u5207\u3063\u3066\u3044\u306A\u3044\u30AB\u30C6\u30B4\u30EA\u30FC\u3084\u58F2\u5834\u3082\u3042\u308A\u307E\u3059\u3002\u4E00\u65B9\u3067\u3001\u4ED6\u306E\u30C8\u30E9\u30A4\u30A2\u30EB\u897F\u53CB\u5E97\u8217\u3067\u306F\u3001\u3059\u3067\u306B\u6210\u679C\u304C\u51FA\u3066\u3044\u308B\u53D6\u308A\u7D44\u307F\u3082\u3042\u308A\u307E\u3059\u3002\u30C8\u30E9\u30A4\u30A2\u30EB\u3067\u306F\u3001\u5404\u5E97\u8217\u3084\u5404\u62C5\u5F53\u8005\u306E\u53D6\u308A\u7D44\u307F\u3001\u6210\u529F\u4E8B\u4F8B\u306A\u3069\u3092\u5171\u6709\u3059\u308B\u4ED5\u7D44\u307F\u304C\u3042\u308A\u307E\u3059\u3002", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("br", {}), "\u4ECA\u5F8C\u306F\u3001\u305D\u3046\u3057\u305F\u6210\u529F\u4E8B\u4F8B\u3092\u81EA\u5E97\u306B\u3082\u7D20\u65E9\u304F\u53D6\u308A\u5165\u308C\u3001\u7D99\u7D9A\u7684\u306B\u30A2\u30C3\u30D7\u30C7\u30FC\u30C8\u3057\u3066\u3044\u304F\u3053\u3068\u304C\u91CD\u8981\u3060\u3068\u8003\u3048\u3066\u3044\u307E\u3059\u306E\u3067\u3001", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(HighlightText, {
                    children: "\u65B0\u3057\u3044\u53D6\u308A\u7D44\u307F\u3092\u67D4\u8EDF\u306B\u53D7\u3051\u5165\u308C\u3001\u5B9F\u884C\u3067\u304D\u308B\u5E97\u8217\u3065\u304F\u308A\u306B\u6311\u6226\u3057\u3066\u3044\u304D\u305F\u3044\u3067\u3059"
                  }), "\u3002"]
                })]
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(LastQAImage, {
              src: "/images/topics_cocotora62.png",
              alt: "\u5E97\u9577\u30A4\u30F3\u30BF\u30D3\u30E5\u30FC"
            })]
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(BottomFlex, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(PersonLeft, {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(PersonTopText, {
              children: "\uFF3C \u3053\u306E\u65B9\u306B\u805E\u304D\u307E\u3057\u305F \uFF0F"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(PersonImageSmall, {
              src: "/images/topics_cocotora63.png",
              alt: "\u9CE5\u8C37\u90E8 \u548C\u4E16"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(PersonInfo, {
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("p", {
                children: "\u30C8\u30E9\u30A4\u30A2\u30EB\u897F\u53CB \u82B1\u5C0F\u91D1\u4E95\u5E97\u9577"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("p", {
                children: "\u9CE5\u8C37\u90E8 \u548C\u4E16"
              })]
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(MessageRight, {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(MessageBox, {
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(MessageTitleWrapper, {
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(MessageTitle, {
                  children: "\u682A\u4E3B\u30FB\u6295\u8CC7\u5BB6\u306E\u7686\u3055\u307E\u3078"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(MessageContent, {
                children: ["\u300C\u30C8\u30E9\u30A4\u30A2\u30EB\u300D\u3068\u3044\u3046\u793E\u540D\u305D\u306E\u3082\u306E\u304C\u3001\u79C1\u305F\u3061\u3089\u3057\u3055\u3092\u8868\u3057\u3066\u3044\u308B\u3068\u601D\u3044\u307E\u3059\u3002", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("br", {}), "\u79C1\u305F\u3061\u306F\u3001\u5931\u6557\u3057\u3066\u3082\u8AE6\u3081\u305A\u3001\u30EA\u30AB\u30D0\u30EA\u30FC\u3057\u306A\u304C\u3089\u6700\u5F8C\u307E\u3067\u3084\u308A\u5207\u308B\u4F1A\u793E\u3067\u3059\u3002", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("br", {}), "\u3053\u308C\u307E\u3067\u897F\u53CB\u3067\u306F\u3001\u3084\u308A\u305F\u304F\u3066\u3082\u8AE6\u3081\u3056\u308B\u3092\u5F97\u306A\u304B\u3063\u305F\u3053\u3068\u3082\u3042\u308A\u307E\u3057\u305F\u3002", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("br", {}), "\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u5165\u308A\u3092\u6A5F\u306B\u3001\u305D\u3053\u304B\u3089\u3055\u3089\u306B\u5927\u304D\u306A\u6311\u6226\u304C\u3067\u304D\u308B\u74B0\u5883\u306B\u306A\u3063\u3066\u3044\u307E\u3059\u3002\u3053\u308C\u304B\u3089\u3082\u5F53\u793E\u30B0\u30EB\u30FC\u30D7\u306E\u30C8\u30E9\u30A4\u3057\u7D9A\u3051\u308B\u59FF\u306B\u671F\u5F85\u3057\u3001\u5FDC\u63F4\u3057\u3066\u3044\u305F\u3060\u3051\u308C\u3070\u3046\u308C\u3057\u3044\u3067\u3059\u3002"]
              })]
            })
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(SectionTitle, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
            children: "\u25CF"
          }), " Web\u30DE\u30AC\u30B8\u30F3", '　', "\u304F\u3089\u3057\u30C8\u30E9\u30A4\u306E\u3054\u7D39\u4ECB"]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(SectionText, {
          children: ["\u300C\u304F\u3089\u3057\u30C8\u30E9\u30A4\u300D\u3067\u306F\u3001\u304A\u3059\u3059\u3081\u5546\u54C1\u3084\u66AE\u3089\u3057\u306B\u5F79\u7ACB\u3064\u60C5\u5831\u3092\u65E5\u3005\u767A\u4FE1\u3057\u3066\u3044\u307E\u3059\u3002", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("br", {}), "\u6BCE\u65E5\u306E\u98DF\u5353\u304C\u3082\u3063\u3068\u697D\u3057\u304F\u306A\u308B\u30A2\u30A4\u30C7\u30A2\u3084\u3001\u5546\u54C1\u306E\u88CF\u5074\u306B\u3042\u308B\u30B9\u30C8\u30FC\u30EA\u30FC\u3092\u304A\u5C4A\u3051\u3057\u307E\u3059\u3002"]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(MagazineGrid, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(MagazineItem, {
            href: "https://www.trial-net.co.jp/mag/detail/30730/?utm_source=IR&utm_medium=tsushin&utm_campaign=TRIALMAGAZINE&utm_content=shioya/mizu",
            target: "_blank",
            rel: "noopener noreferrer",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("img", {
              src: "/images/topics_cocotora45.png",
              alt: "\u5929\u7136\u6C34"
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(MagazineItem, {
            href: "https://www.trial-net.co.jp/mag/detail/24474/?utm_source=IR&utm_medium=tsushin&utm_campaign=TRIALMAGAZINE&utm_content=nabetsuyu",
            target: "_blank",
            rel: "noopener noreferrer",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("img", {
              src: "/images/topics_cocotora46.png",
              alt: "\u934B\u3064\u3086"
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(MagazineItem, {
            href: "https://www.trial-net.co.jp/mag/detail/30565/?utm_source=IR&utm_medium=tsushin&utm_campaign=TRIALMAGAZINE&utm_content=toripaitan",
            target: "_blank",
            rel: "noopener noreferrer",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("img", {
              src: "/images/topics_cocotora47.png",
              alt: "\u9D8F\u767D\u6E6F"
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(MagazineItem, {
            href: "https://www.trial-net.co.jp/mag/detail/23626/?utm_source=IR&utm_medium=tsushin&utm_campaign=TRIALMAGAZINE&utm_content=trial/plus",
            target: "_blank",
            rel: "noopener noreferrer",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("img", {
              src: "/images/topics_cocotora48.png",
              alt: "\u30C8\u30E9\u30A4\u30A2\u30EB\uFF0B"
            })
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(DownArrowSection, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(DownArrowRow, {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(DownArrow, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(DownArrowText, {
              children: "\u3053\u3061\u3089\u304B\u3089\u3082\u3054\u89A7\u3044\u305F\u3060\u3051\u307E\u3059"
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(DownArrowImageLink, {
            href: "https://www.trial-net.co.jp/mag/?utm_source=IR&utm_medium=tsushin&utm_campaign=TRIALMAGAZINE&utm_content=TRIALMAGAZINE",
            target: "_blank",
            rel: "noopener noreferrer",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("img", {
              src: "/images/topics_cocotora_31.png",
              alt: "\u304F\u3089\u3057\u30C8\u30E9\u30A4"
            })
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(SectionTitle, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
            children: "\u25CF"
          }), " \u5E97\u8217\u691C\u7D22\u30B5\u30A4\u30C8\u30FB\u516C\u5F0FInstagram\u306E\u3054\u7D39\u4ECB"]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(SectionText, {
          children: "\u304A\u8FD1\u304F\u306E\u5E97\u8217\u306E\u691C\u7D22\u3084\u3001\u6700\u65B0\u306E\u304A\u5F97\u306A\u60C5\u5831\u30FB\u30AD\u30E3\u30F3\u30DA\u30FC\u30F3\u306A\u3069\u3092\u3054\u78BA\u8A8D\u3044\u305F\u3060\u3051\u307E\u3059\u3002"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(StoreLinksFlex, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(StoreLinksColumn, {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(StoreMainImage, {
              src: "/images/topics_cocotora49.png",
              alt: "\u30C8\u30E9\u30A4\u30A2\u30EB"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(StoreSubFlex, {
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(StoreSubColumn, {
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(StoreSubItem, {
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(StoreSubIcon, {
                    src: "/images/topics_cocotora50.png",
                    alt: "\u5E97\u8217\u691C\u7D22"
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(StoreLink, {
                    href: "https://www.trial-net.co.jp/shops",
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: "\u30C8\u30E9\u30A4\u30A2\u30EB\u306E\u5E97\u8217\u3092\u63A2\u3059"
                  })]
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(StoreSubItem, {
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(StoreSubIconLast, {
                    src: "/images/topics_cocotora51.png",
                    alt: "Instagram"
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(StoreLink, {
                    href: "https://www.instagram.com/trialcompany_official?stkn=cmp3Y2U5czRpcHgw&utm_source=qr?utm_source=HP&utm_medium=Instagram&utm_campaign=Instagram&utm_content=profile",
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: "\u30C8\u30E9\u30A4\u30A2\u30EB\u516C\u5F0FInstagram"
                  })]
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(StoreSubRight, {
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(StoreSubRightImage, {
                  src: "/images/topics_cocotora52.png",
                  alt: "trialcompany_official"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(StoreSubRightText, {
                  children: "trialcompany_official"
                })]
              })]
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(StoreLinksColumn, {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(StoreMainImage, {
              src: "/images/topics_cocotora_40.png",
              alt: "\u897F\u53CB"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(StoreSubFlex, {
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(StoreSubColumn, {
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(StoreSubItem, {
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(StoreSubIcon, {
                    src: "/images/topics_cocotora50.png",
                    alt: "\u5E97\u8217\u691C\u7D22"
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(StoreLink, {
                    href: "https://www.seiyu.co.jp/searchshop/",
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: "\u897F\u53CB\u306E\u5E97\u8217\u3092\u63A2\u3059"
                  })]
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(StoreSubItem, {
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(StoreSubIconLast, {
                    src: "/images/topics_cocotora51.png",
                    alt: "Instagram"
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(StoreLink, {
                    href: "https://www.instagram.com/seiyu_official/",
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: "\u897F\u53CB\u516C\u5F0FInstagram"
                  })]
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(StoreSubRight, {
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(StoreSubRightImage, {
                  src: "/images/topics_cocotora53.png",
                  alt: "seiyu_official"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(StoreSubRightText, {
                  children: "seiyu_official"
                })]
              })]
            })]
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(VideoLinksFlex, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(VideoLink, {
            href: "https://youtu.be/xykrw7-i4mQ?si=kkx3JNJWemUW63x3",
            target: "_blank",
            rel: "noopener noreferrer",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("img", {
              src: "/images/topics_cocotora54.png",
              alt: "HD\u7D39\u4ECB"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(VideoLinkText, {
              children: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9\u7D39\u4ECB\u52D5\u753B"
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(VideoLink, {
            href: "https://youtu.be/LAGfCH5c2yg?si=4j6-mXOK0az7hrLl",
            target: "_blank",
            rel: "noopener noreferrer",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("img", {
              src: "/images/topics_cocotora55.png",
              alt: "\u6D41\u901A\u60C5\u5831\u9769\u547D"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(VideoLinkText, {
              children: "Retail AI \u6D41\u901A\u60C5\u5831\u9769\u547D"
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(VideoLink, {
            href: "https://youtu.be/-I48rKRbsvw?si=JSvvLld6si1czUYd",
            target: "_blank",
            rel: "noopener noreferrer",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("img", {
              src: "/images/topics_cocotora56.png",
              alt: "\u5BAE\u82E5"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(VideoLinkText, {
              children: "\u798F\u5CA1\u770C\u5BAE\u82E5\u5E02\u3067\u3001\u30EA\u30C6\u30FC\u30EBDX\u63A8\u9032"
            })]
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components_layouts_Ir_Pdffiles__WEBPACK_IMPORTED_MODULE_3__/* .MonthlySalesPDF */ .s, {
          yearsPdf: yearsPdf
        })]
      })
    })]
  });
};

var CompanyMain = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora__CompanyMain",
  componentId: "sc-1m0bh2u-0"
})(["width:1040px;margin:0 auto;padding:98px 0 130px;@media screen and (max-width:1047px){width:100%;padding:40px 20px 70px;}"]);
var TopicsSection = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora__TopicsSection",
  componentId: "sc-1m0bh2u-1"
})(["width:1040px;margin:0 auto;padding:30px 0 130px;img{width:100%;}@media screen and (max-width:1047px){width:100%;padding:40px 20px 70px;}"]);
var TopicsTitleBuild = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora__TopicsTitleBuild",
  componentId: "sc-1m0bh2u-2"
})(["width:100%;padding:15px 10px;font-size:32px;font-weight:bold;color:#FFF;margin-top:50px;background:", ";@media screen and (max-width:1047px){font-size:18px;line-height:26px;margin-top:30px;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue);
var TopicsTitleBuildDate = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "topics-cocotora__TopicsTitleBuildDate",
  componentId: "sc-1m0bh2u-3"
})(["font-size:18px;font-weight:bold;color:#FFF;margin-left:10px;@media screen and (max-width:1047px){font-size:14px;margin-left:5px;}"]);
var IntroText = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora__IntroText",
  componentId: "sc-1m0bh2u-4"
})(["margin-top:40px;margin-bottom:50px;text-align:center;font-size:22px;font-weight:bold;color:#2F5597;line-height:36px;@media screen and (max-width:1047px){font-size:15px;line-height:24px;margin-top:20px;margin-bottom:30px;.pc-only{display:none;}}"]);
var SectionTitle = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora__SectionTitle",
  componentId: "sc-1m0bh2u-5"
})(["margin-top:60px;font-size:26px;font-weight:bold;color:#333;line-height:34px;span{margin-right:8px;}@media screen and (max-width:1047px){font-size:18px;line-height:26px;margin-top:40px;}"]);
var SectionTitleFlex = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora__SectionTitleFlex",
  componentId: "sc-1m0bh2u-6"
})(["margin-top:60px;display:flex;justify-content:space-between;align-items:center;gap:20px;@media screen and (max-width:1047px){margin-top:40px;flex-direction:column;align-items:flex-start;gap:15px;}"]);
var SectionTitleText = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora__SectionTitleText",
  componentId: "sc-1m0bh2u-7"
})(["font-size:26px;font-weight:bold;color:#333;line-height:34px;flex:1;span{margin-right:8px;}@media screen and (max-width:1047px){font-size:18px;line-height:26px;}"]);
var SectionTitleImage = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].img.withConfig */ .ZP.img.withConfig({
  displayName: "topics-cocotora__SectionTitleImage",
  componentId: "sc-1m0bh2u-8"
})(["width:290px !important;height:100px;object-fit:contain;flex-shrink:0;@media screen and (max-width:1047px){width:200px !important;height:70px;align-self:flex-end;}"]);
var BirthFlex = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora__BirthFlex",
  componentId: "sc-1m0bh2u-9"
})(["display:flex;align-items:center;gap:30px;margin-top:20px;@media screen and (max-width:1047px){flex-direction:column;gap:15px;}"]);
var BirthImage = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].img.withConfig */ .ZP.img.withConfig({
  displayName: "topics-cocotora__BirthImage",
  componentId: "sc-1m0bh2u-10"
})(["width:218px !important;height:50px;object-fit:contain;flex-shrink:0;@media screen and (max-width:1047px){width:180px !important;height:42px;align-self:flex-start;}"]);
var BirthText = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora__BirthText",
  componentId: "sc-1m0bh2u-11"
})(["font-size:24px;font-weight:bold;color:#2F5597;line-height:36px;.sp-only{display:none;}@media screen and (max-width:1047px){font-size:18px;line-height:28px;.sp-only{display:inline;}}"]);
var SectionText = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "topics-cocotora__SectionText",
  componentId: "sc-1m0bh2u-12"
})(["font-size:18px;line-height:32px;color:#333;margin-top:20px;@media screen and (max-width:1047px){font-size:14px;line-height:26px;}"]);
var ScrollableImageWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora__ScrollableImageWrapper",
  componentId: "sc-1m0bh2u-13"
})(["width:100%;overflow-x:auto;margin-top:30px;-webkit-overflow-scrolling:touch;scrollbar-width:none;&::-webkit-scrollbar{display:none;}@media screen and (max-width:1047px){overflow-x:visible;}"]);
var ScrollableImage = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].img.withConfig */ .ZP.img.withConfig({
  displayName: "topics-cocotora__ScrollableImage",
  componentId: "sc-1m0bh2u-14"
})(["display:block;min-width:1040px;width:100%;max-width:none;@media screen and (max-width:1047px){min-width:0;width:100%;}"]);
var QASection = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora__QASection",
  componentId: "sc-1m0bh2u-15"
})(["margin-top:20px;display:flex;flex-direction:column;gap:50px;@media screen and (max-width:1047px){margin-top:40px;gap:30px;}"]);
var QABlock = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora__QABlock",
  componentId: "sc-1m0bh2u-16"
})(["display:flex;flex-direction:column;gap:20px;@media screen and (max-width:1047px){gap:15px;}"]);
var QARow = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora__QARow",
  componentId: "sc-1m0bh2u-17"
})(["display:flex;align-items:flex-start;gap:15px;@media screen and (max-width:1047px){gap:10px;}"]);
var QIcon = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora__QIcon",
  componentId: "sc-1m0bh2u-18"
})(["width:36px;height:36px;border-radius:50%;background:#002D65;color:#FFF;font-weight:bold;font-size:20px;display:flex;align-items:center;justify-content:center;flex-shrink:0;margin-top:2px;@media screen and (max-width:1047px){width:28px;height:28px;font-size:16px;}"]);
var AIcon = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora__AIcon",
  componentId: "sc-1m0bh2u-19"
})(["width:36px;height:36px;border-radius:50%;background:#C2CDDA;color:#002D65;font-weight:bold;font-size:20px;display:flex;align-items:center;justify-content:center;flex-shrink:0;margin-top:2px;@media screen and (max-width:1047px){width:28px;height:28px;font-size:16px;}"]);
var QText = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora__QText",
  componentId: "sc-1m0bh2u-20"
})(["font-size:18px;font-weight:bold;color:#333333;line-height:30px;padding-top:3px;@media screen and (max-width:1047px){font-size:15px;line-height:24px;}"]);
var AText = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora__AText",
  componentId: "sc-1m0bh2u-21"
})(["font-size:16px;font-weight:normal;color:#333333;line-height:28px;padding-top:3px;@media screen and (max-width:1047px){font-size:14px;line-height:24px;}"]);
var HighlightText = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "topics-cocotora__HighlightText",
  componentId: "sc-1m0bh2u-22"
})(["color:#002D65;font-weight:bold;"]);
var LastQARow = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora__LastQARow",
  componentId: "sc-1m0bh2u-23"
})(["display:flex;align-items:flex-start;gap:30px;@media screen and (max-width:1047px){flex-direction:column;gap:20px;}"]);
var LastQAColumn = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora__LastQAColumn",
  componentId: "sc-1m0bh2u-24"
})(["flex:1;display:flex;flex-direction:column;gap:20px;@media screen and (max-width:1047px){gap:15px;}"]);
var LastQAImage = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].img.withConfig */ .ZP.img.withConfig({
  displayName: "topics-cocotora__LastQAImage",
  componentId: "sc-1m0bh2u-25"
})(["width:320px !important;height:170px;object-fit:contain;flex-shrink:0;@media screen and (max-width:1047px){width:100%;max-width:320px;height:auto;align-self:center;}"]);
var BottomFlex = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora__BottomFlex",
  componentId: "sc-1m0bh2u-26"
})(["display:flex;justify-content:space-between;align-items:flex-start;gap:40px;margin-top:60px;@media screen and (max-width:1047px){flex-direction:column;gap:30px;margin-top:40px;}"]);
var PersonLeft = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora__PersonLeft",
  componentId: "sc-1m0bh2u-27"
})(["width:30%;display:flex;flex-direction:column;align-items:center;@media screen and (max-width:1047px){width:100%;}"]);
var PersonTopText = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora__PersonTopText",
  componentId: "sc-1m0bh2u-28"
})(["font-size:20px;font-weight:bold;color:#333;margin-bottom:15px;@media screen and (max-width:1047px){font-size:16px;}"]);
var PersonImage = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].img.withConfig */ .ZP.img.withConfig({
  displayName: "topics-cocotora__PersonImage",
  componentId: "sc-1m0bh2u-29"
})(["width:235px !important;height:170px;object-fit:cover;margin-bottom:15px;@media screen and (max-width:1047px){width:200px !important;height:145px;}"]);
var PersonImageSmall = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].img.withConfig */ .ZP.img.withConfig({
  displayName: "topics-cocotora__PersonImageSmall",
  componentId: "sc-1m0bh2u-30"
})(["width:145px !important;height:150px;object-fit:cover;margin-bottom:15px;@media screen and (max-width:1047px){width:120px !important;height:125px;}"]);
var PersonInfo = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora__PersonInfo",
  componentId: "sc-1m0bh2u-31"
})(["text-align:center;font-size:18px;font-weight:bold;color:#333;line-height:30px;p{margin:0;}@media screen and (max-width:1047px){font-size:15px;line-height:26px;}"]);
var MessageRight = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora__MessageRight",
  componentId: "sc-1m0bh2u-32"
})(["width:65%;position:relative;padding-top:20px;@media screen and (max-width:1047px){width:100%;}"]);
var MessageBox = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora__MessageBox",
  componentId: "sc-1m0bh2u-33"
})(["border:2px dashed #999;padding:40px 30px 30px;position:relative;@media screen and (max-width:1047px){padding:30px 15px 20px;}"]);
var MessageTitleWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora__MessageTitleWrapper",
  componentId: "sc-1m0bh2u-34"
})(["position:absolute;top:-14px;left:20px;background:#FFF;padding:0 12px;"]);
var MessageTitle = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora__MessageTitle",
  componentId: "sc-1m0bh2u-35"
})(["font-size:20px;font-weight:bold;color:#333;@media screen and (max-width:1047px){font-size:16px;}"]);
var MessageContent = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora__MessageContent",
  componentId: "sc-1m0bh2u-36"
})(["font-size:16px;line-height:30px;color:#333;@media screen and (max-width:1047px){font-size:13px;line-height:24px;.pc-only{display:none;}}"]);
var InsideGrid = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora__InsideGrid",
  componentId: "sc-1m0bh2u-37"
})(["display:grid;grid-template-columns:repeat(2,1fr);gap:40px;margin-top:30px;& > *:nth-child(1){order:1;}& > *:nth-child(2){order:3;}& > *:nth-child(3){order:2;}& > *:nth-child(4){order:4;}@media screen and (max-width:1047px){grid-template-columns:1fr;gap:30px;margin-top:20px;& > *:nth-child(1){order:1;}& > *:nth-child(2){order:2;}& > *:nth-child(3){order:3;}& > *:nth-child(4){order:4;}}"]);
var InsideReplaceImage = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].img.withConfig */ .ZP.img.withConfig({
  displayName: "topics-cocotora__InsideReplaceImage",
  componentId: "sc-1m0bh2u-38"
})(["display:block;width:100%;height:auto;object-fit:contain;@media screen and (max-width:1047px){width:100%;}"]);
var MagazineGrid = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora__MagazineGrid",
  componentId: "sc-1m0bh2u-39"
})(["display:grid;grid-template-columns:repeat(2,1fr);gap:30px;margin-top:30px;@media screen and (max-width:1047px){gap:15px;margin-top:20px;}"]);
var MagazineItem = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].a.withConfig */ .ZP.a.withConfig({
  displayName: "topics-cocotora__MagazineItem",
  componentId: "sc-1m0bh2u-40"
})(["display:block;transition:opacity 0.3s;&:hover{opacity:0.8;}img{width:100%;height:auto;display:block;}"]);
var DownArrowSection = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora__DownArrowSection",
  componentId: "sc-1m0bh2u-41"
})(["display:flex;flex-direction:column;align-items:center;margin-top:50px;@media screen and (max-width:1047px){margin-top:30px;}"]);
var DownArrowRow = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora__DownArrowRow",
  componentId: "sc-1m0bh2u-42"
})(["display:flex;align-items:center;justify-content:center;gap:10px;margin-bottom:15px;"]);
var DownArrow = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora__DownArrow",
  componentId: "sc-1m0bh2u-43"
})(["width:0;height:0;border-left:15px solid transparent;border-right:15px solid transparent;border-top:20px solid #333;flex-shrink:0;@media screen and (max-width:1047px){border-left:10px solid transparent;border-right:10px solid transparent;border-top:14px solid #333;}"]);
var DownArrowText = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora__DownArrowText",
  componentId: "sc-1m0bh2u-44"
})(["font-size:18px;font-weight:bold;color:#333;@media screen and (max-width:1047px){font-size:15px;}"]);
var DownArrowImageLink = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].a.withConfig */ .ZP.a.withConfig({
  displayName: "topics-cocotora__DownArrowImageLink",
  componentId: "sc-1m0bh2u-45"
})(["display:block;max-width:400px;width:100%;img{width:100%;height:auto;}@media screen and (max-width:1047px){width:50%;margin:0 auto;}"]);
var StoreLinksFlex = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora__StoreLinksFlex",
  componentId: "sc-1m0bh2u-46"
})(["display:flex;gap:50px;margin-top:30px;@media screen and (max-width:1047px){flex-direction:column;gap:30px;}"]);
var StoreLinksColumn = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora__StoreLinksColumn",
  componentId: "sc-1m0bh2u-47"
})(["flex:1;"]);
var StoreMainImage = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].img.withConfig */ .ZP.img.withConfig({
  displayName: "topics-cocotora__StoreMainImage",
  componentId: "sc-1m0bh2u-48"
})(["width:180px !important;object-fit:contain;display:block;margin-bottom:20px;margin-top:20px;@media screen and (max-width:1047px){width:140px !important;height:18px;}"]);
var StoreSubFlex = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora__StoreSubFlex",
  componentId: "sc-1m0bh2u-49"
})(["display:flex;justify-content:space-between;align-items:flex-start;gap:20px;margin-left:30px;"]);
var StoreSubColumn = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora__StoreSubColumn",
  componentId: "sc-1m0bh2u-50"
})(["display:flex;flex-direction:column;gap:15px;flex:1;"]);
var StoreSubItem = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora__StoreSubItem",
  componentId: "sc-1m0bh2u-51"
})(["display:flex;align-items:center;gap:10px;"]);
var StoreSubIcon = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].img.withConfig */ .ZP.img.withConfig({
  displayName: "topics-cocotora__StoreSubIcon",
  componentId: "sc-1m0bh2u-52"
})(["width:50px !important;height:50px;object-fit:contain;flex-shrink:0;"]);
var StoreSubIconLast = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].img.withConfig */ .ZP.img.withConfig({
  displayName: "topics-cocotora__StoreSubIconLast",
  componentId: "sc-1m0bh2u-53"
})(["width:45px !important;height:45px;object-fit:contain;flex-shrink:0;"]);
var StoreLink = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].a.withConfig */ .ZP.a.withConfig({
  displayName: "topics-cocotora__StoreLink",
  componentId: "sc-1m0bh2u-54"
})(["font-size:18px;color:#333;text-decoration:underline;font-weight:bold;&:hover{opacity:0.7;color:#3786C7;}@media screen and (max-width:1047px){font-size:14px;}"]);
var StoreSubRight = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora__StoreSubRight",
  componentId: "sc-1m0bh2u-55"
})(["display:flex;flex-direction:column;align-items:center;flex-shrink:0;@media screen and (max-width:1047px){width:140px;}"]);
var StoreSubRightImage = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].img.withConfig */ .ZP.img.withConfig({
  displayName: "topics-cocotora__StoreSubRightImage",
  componentId: "sc-1m0bh2u-56"
})(["width:100px !important;height:100px;object-fit:cover;display:block;@media screen and (max-width:1047px){width:70px !important;height:70px;}"]);
var StoreSubRightText = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora__StoreSubRightText",
  componentId: "sc-1m0bh2u-57"
})(["font-size:14px;color:#333;margin-top:8px;text-align:center;@media screen and (max-width:1047px){font-size:12px;}"]);
var VideoLinksFlex = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora__VideoLinksFlex",
  componentId: "sc-1m0bh2u-58"
})(["display:flex;gap:30px;margin-top:60px;margin-bottom:60px;@media screen and (max-width:1047px){flex-direction:column;gap:20px;margin-top:40px;}"]);
var VideoLink = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].a.withConfig */ .ZP.a.withConfig({
  displayName: "topics-cocotora__VideoLink",
  componentId: "sc-1m0bh2u-59"
})(["flex:1;display:block;transition:opacity 0.3s;text-align:center;&:hover{opacity:0.8;}img{width:100%;height:auto;display:block;}"]);
var VideoLinkText = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora__VideoLinkText",
  componentId: "sc-1m0bh2u-60"
})(["margin-top:12px;font-size:16px;font-weight:bold;color:#333;line-height:26px;@media screen and (max-width:1047px){font-size:14px;line-height:22px;margin-top:8px;}"]);

/***/ }),

/***/ 16645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bp": function() { return /* binding */ isEqualYear; },
/* harmony export */   "dG": function() { return /* binding */ isEqualMonth; },
/* harmony export */   "p6": function() { return /* binding */ formatDate; }
/* harmony export */ });
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72167);

var formatDate = function formatDate(date, formatType) {
  try {
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(new Date(date), formatType);
  } catch (e) {
    return date;
  }
};
var isEqualYear = function isEqualYear(date, year) {
  return formatDate(date, 'yyyy') === year;
};
var isEqualMonth = function isEqualMonth(date, month) {
  return formatDate(date, 'M') === month;
};

/***/ }),

/***/ 41281:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/retail-investor/topics-cocotora",
      function () {
        return __webpack_require__(15532);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(16505)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,3874,2768,2167,5548,9774,2888,179], function() { return __webpack_exec__(41281); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);